<template>
  <BTableCommon
    v-model="selected"
    type="users-participants"
    :list="list"
    :pagination="pagination"
    :ordering="filters.ordering"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    @change:pagination="onChangePagination"
    @change:sort="onChangeSort"
    @action:delete="onRemove"
  />
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { UsersParticipantsModel as Model } from './Model'
import {
  usersParticipantsStoreModule as StoreModule,
} from './store'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import { ParticipantsApi } from '@/api/resources'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewUsersParticipantsList',
  components: {
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  props: {
    user_id: {
      type: [Number, String],
      required: true,
    },
  },
  data: (vm) => ({
    isLoading: false,
    defaultParams: {
      user_id: vm.user_id,
    },
  }),
  methods: {
    async onRemove(data) {
      const api = new ParticipantsApi()
      this.isLoading = true
      try {
        await api.removeUser(data.id, { user_id: this.user_id })
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
      this.asyncData()
    },
  },
}
</script>
